<template>
    <div class>
        <STable ref="tableref" :url="url" :columns="columns" :handles="handles" :query="query" :toolbar="toolbar"
            :selection="false" label-width="120px" />
    </div>
</template>

<script>
import { HOST } from "@/utils/host";
export default {
    name: "Shishidingdan",
    components: {},
    data() {
        return {
            url: "/finance/order/getHistoryOrder?view=USER&orderStatus=1",
            columns: [
                {
                    label: "充电单号",
                    prop: "startChargeSeq",
                },
                {
                    label: "用户账号",
                    prop: "loginName",
                },
                {
                    label: "归属企业",
                    prop: "belongOrg",
                },
                {
                    label: "充电车辆",
                    prop: "plateNumber",
                },
                {
                    label: "车辆VIN码",
                    prop: "VINCode",
                },
                {
                    label: "充电方式",
                    prop: "chargeTypeValue",
                },
                // {
                //   label: '订单金额',
                //   prop: 'totalMoney',
                //   template: (index, reocrd) => {
                //     return this.getFloat(reocrd.totalMoney)
                //   }
                // },
                {
                    label: "应收金额",
                    prop: "totalMoney",
                },
                {
                    label: "应收电费",
                    prop: "elecMoney",
                },
                {
                    label: "应收服务费",
                    prop: "serviceMoney",
                },
                {
                    label: "实收金额",
                    prop: "totalMoneyActual",
                    template: (index, reocrd) => {
                        return this.getFixed2(reocrd.totalMoneyActual);
                    },
                },
                {
                    label: "实收电费",
                    prop: "elecMoneyActual",
                },
                {
                    label: "实收服务费",
                    prop: "serviceMoneyActual",
                },
                {
                    label: "优惠抵扣金额",
                    prop: "discountMoney",
                },
                {
                    label: "开始充电时间",
                    prop: "startTime",
                    width: "150px",
                },
                {
                    label: "结束充电时间",
                    prop: "endTime",
                    width: "150px",
                    template: (index, reocrd) => {
                        return reocrd.endTime ? reocrd.endTime : "--";
                    },
                },
                {
                    label: "订单支付时间",
                    prop: "payTime",
                    width: "150px",
                },
                {
                    label: "充电时长",
                    prop: "chargeTime",
                },
                {
                    label: "已充电量（度）",
                    prop: "totalPower",
                    template: (index, reocrd) => {
                        return this.getFloat(reocrd.totalPower);
                    },
                },
                {
                    label: "起始SOC",
                    prop: "startSOC",
                    template: (index, reocrd) => {
                        return reocrd.startSOC ? parseFloat(reocrd.startSOC) + "%" : "--";
                    },
                },
                {
                    label: "结束SOC",
                    prop: "endSOC",
                    template: (index, reocrd) => {
                        return reocrd.endSOC ? parseFloat(reocrd.endSOC) + "%" : "--";
                    },
                },
                {
                    label: "电站名称",
                    prop: "stationName",
                },
                {
                    label: "终端名称",
                    prop: "connectorName",
                },
                // {
                //   label: "电桩功率",
                //   prop: "connectorPower"
                // },
                {
                    label: "运营商",
                    prop: "orgName",
                },
                {
                    label: "订单类型",
                    prop: "orderTypeValue",
                },
                {
                    label: "互联互通订单号",
                    prop: "hlhtStartChargeSeq",
                },
                // {
                //   label: "充电模式",
                //   prop: "chargeMode"
                // }
            ],
            // 操作栏
            handles: {
                width: 80,
                btns: [
                    {
                        label: "详情",
                        icon: "el-icon-view",
                        permission: "order.userhistory.details",
                        handle: (resp) => {
                            this.$router.push({
                                path: "./historyDetail",
                                query: { data: resp.id, num: resp.startChargeSeq },
                            });
                        },
                    },
                ],
            },
            query: [
                {
                    label: "开始充电",
                    prop: "startTime",
                    placeholder: "",
                    type: "date2",
                },
                {
                    label: "结束充电",
                    prop: "endTime",
                    placeholder: "",
                    type: "date2",
                },
                {
                    label: "充电单号",
                    prop: "startChargeSeq",
                    placeholder: "请输入充电单号",
                },
                {
                    label: "充电方式",
                    prop: "chargeType",
                    placeholder: "请输入充电方式",
                    type: "select",
                    data: [
                        {
                            label: "平台APP",
                            value: "APP",
                        },
                        {
                            label: "平台小程序",
                            value: "WSP",
                        },
                        {
                            label: "平台刷卡",
                            value: "CARD",
                        },
                        {
                            label: "第三方",
                            value: "OTHER",
                        },
                        {
                            label: "VIN码充电",
                            value: "VIN",
                        },
                    ],
                },
                {
                    label: "用户账号",
                    prop: "loginName",
                    placeholder: "请输入用户账号",
                },
                {
                    label: "用户姓名",
                    prop: "userName",
                    placeholder: "请输入用户姓名",
                },
                {
                    label: "归属企业",
                    prop: "belongOrg",
                    placeholder: "请输入归属企业",
                },
                {
                    label: "订单类型",
                    prop: "orderType",
                    placeholder: "请选择订单类型",
                    type: "select",
                    data: [
                        {
                            label: "平台",
                            value: 0,
                        },
                        {
                            label: "流量方",
                            value: 1,
                        },
                        // {
                        //   label: "车辆机构",
                        //   value: 2
                        // },
                    ],
                },
                {
                    label: "电站名称",
                    prop: "stationName",
                    placeholder: "请输入电站名称",
                },
                {
                    label: "终端名称",
                    prop: "connectorName",
                    placeholder: "请输入终端名称",
                },
                {
                    label: "运营商",
                    prop: "orgName",
                    placeholder: "请输入运营商",
                },
                {
                    label: "运营商属性",
                    prop: "orgType",
                    placeholder: "请选择运营商属性",
                    type: "select",
                    data: [
                        {
                            label: "自营",
                            value: 0,
                        },
                        {
                            label: "加盟",
                            value: 1,
                        },
                        {
                            label: "互联互通",
                            value: 2,
                        },
                    ],
                },
                {
                    label: "订单结算",
                    prop: "payTime",
                    placeholder: "",
                    type: "date2",
                },
                {
                    label: "结算方式",
                    prop: "payType",
                    placeholder: "请选择结算方式",
                    type: "select",
                    data: [
                        {
                            label: "正常结算",
                            value: 0,
                        },
                        {
                            label: "手动结算",
                            value: 1,
                        },
                    ],
                },
                {
                    label: "充电车辆",
                    prop: "plateNumber",
                    placeholder: "请输入充电车辆",
                },
                {
                    label: "异常原因",
                    prop: "payTypeDesc",
                    placeholder: "请选择异常原因",
                    type: "select",
                    data: [
                        {
                            label: "无结算数据",
                            value: 1,
                        },
                        {
                            label: "充电时长异常",
                            value: 2,
                        },
                        {
                            label: "充电金额异常",
                            value: 3,
                        },
                        {
                            label: "充电电量异常",
                            value: 4,
                        },
                        {
                            label: "设备离线",
                            value: 5,
                        },
                        {
                            label: "手动转异常",
                            value: 6,
                        },
                    ],
                },
                {
                    label: "互联互通订单号",
                    prop: "hlhtStartChargeSeq",
                    placeholder: "请输入互联互通订单号",
                    width: 160,
                },
                // {
                //   label: '充电卡号',
                //   prop: 'cardNum',
                //   placeholder: '请输入充电卡号'
                // },
                // {
                //   label: '电桩功率',
                //   prop: 'connectorPower',
                //   placeholder: '请输入电桩功率'
                // },
                // {
                //   label: "充电模式",
                //   prop: "chargeMode",
                //   placeholder: "请选择充电模式",
                //   type: "select",
                //   data: [
                //     {
                //       label: "单充",
                //       value: 0
                //     },
                //     {
                //       label: "双枪并充",
                //       value: 1
                //     },
                //   ]
                // },
                // {
                //   label: '支付状态',
                //   prop: 'orderStatus',
                //   placeholder: '请选择支付状态',
                //   type: 'select',
                //   data: [
                //     {
                //       label: '待支付',
                //       value: 0
                //     },
                //     {
                //       label: '已支付',
                //       value: 1
                //     }
                //   ]
                // }
            ],
            toolbar: [
                {
                    label: "导出",
                    icon: "el-icon-download",
                    permission: "order.userhistory.export",
                    type: "primary",
                    handle: (resp) => {
                        const url = HOST + "/finance/order/export?view=USER";
                        const queryData = this.$refs.tableref.getQueryData();
                        queryData.token = window.localStorage.getItem("token");
                        queryData.companyId = window.localStorage.getItem("curCompanyId");
                        $.fileDownload(url, {
                            httpMethod: "get",
                            data: queryData,
                            failCallback: (html, url) => {
                                this.$notify({
                                    title: "失败",
                                    message: "导出失败",
                                    type: "error",
                                });
                            },
                        });
                    },
                },
            ],
        };
    },
    computed: {},
    mounted() { },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { },
    methods: {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/orderManagement/historymanagement.vue